import { EditOutlined } from "@ant-design/icons";
import { Button, InputNumber, Modal, Space, Spin, Typography } from "antd";
import { doc, updateDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { Notification } from "../../../components/Notification";
import { db } from "../../../firebase/config";

const { Text } = Typography;

export default function UpdateUserModal(props) {
   //show/hide modal
   const [isModalOpen, setIsModalOpen] = useState(false);
   //loading
   const [contentLoading, setContentLoading] = useState(true);

   //extra percent data
   const [extraPercent, setExtraPercent] = useState(0);

   //assigns user to props
   const userProp = props.user;

   //fetches the data using useEffect
   useEffect(() => {
      if (isModalOpen) {
         setExtraPercent(userProp.extraPercentage);
      }
      setContentLoading(false);
   }, [isModalOpen, userProp]);

   //handles OK with an update on the user document
   const showModal = () => {
      setIsModalOpen(true);
   };
   const handleOk = () => {
      try {
         const userRef = doc(db, "users", userProp.id);
         updateDoc(userRef, {
            extraPercentage: extraPercent,
         }).then(() => {
            Notification("success", "Updated", "User updated");
         });
      } catch (error) {
         Notification("error", "Error", error.message);
      }
      setIsModalOpen(false);
   };

   //handles cancel
   const handleCancel = () => {
      setIsModalOpen(false);
   };

   //returns spin if content is loading
   if (contentLoading) {
      return <Spin />;
   }
   return (
      <>
         <Button type="text" key="edit" onClick={showModal} icon={<EditOutlined />}>
            Edit
         </Button>
         <Modal title="Edit User" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
            <Space>
               <Text>Percent</Text>
               <InputNumber value={extraPercent} onChange={setExtraPercent} />
            </Space>
         </Modal>
      </>
   );
}
